import request from './request'
import { Toast } from 'vant'
import { setToken, getToken } from '../utils/cache'
import { isApp, getDeviceid } from '../utils/index'
import qs from 'qs'
const KIND = '7' //答题的类型

export function getClockinList(data) {
	data = {
		kind: KIND,
		...data
	}
	return new Promise((resolve, reject) => {
		login().then(() => {
			request({
				url: `/common/clockin${data ? '?' + qs.stringify(data) : ''}`,
				method: 'get',
				headers: {
					Authorization: 'Bearer ' + getToken()
				}
			}).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error) 
			})
		}).catch(error => {
			reject(error)
		})
	})
}

export function doCheck(data) {
	data = {
		kind: KIND,
		...data
	}
	return new Promise((resolve, reject) => {
		login().then(() => {
			request({
				url: '/common/clockin',
				method: 'post',
				data: data,
				headers: {
					Authorization: 'Bearer ' + getToken()
				}
			}).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		}).catch(error => {
			reject(error)
		})
	})
}

export function getClockinRank(data) {
	data = {
		kind: KIND,
		...data
	}
	return new Promise((resolve, reject) => {
		request({
			url: `/common/clockin/rank?${qs.stringify(data)}`,
			method: 'get',
			headers: {
				Authorization: 'Bearer ' + getToken()
			}
		}).then(response => {
			resolve(response)
		}).catch(error => {
			reject(error)
		})
	})
}

export function login(loginInfo) {
	return new Promise((resolve, reject) => {
		if (getToken()) {
			resolve(loginInfo);
			return
		}
		if (isApp()) {
			if (getDeviceid()) {
				request({
					method: 'post',
					url: '/auth/cbgc',
					data: loginInfo
				}).then(function (resp) {
					if (resp.meta && resp.meta.custom && resp.meta.custom.access_token) {
						setToken(resp.meta.custom)
					}
					resolve('app login success');
				})
			} else {
				reject('illegal device!');
				Toast({
					message: '非法的设备,请检查',
					type: 'fail'
				})
			}
		} else {
			reject('no user');
			Toast({
				message: '不支持的参与渠道',
				type: 'fail'
			})
		}
	});

}

